import * as d3 from 'd3';

/**
 * ガウシアンカーネル関数
 */
export function gaussianKernel(x: number): number {
  return (1 / Math.sqrt(2 * Math.PI)) * Math.exp(-0.5 * x * x);
}

/**
 * カーネル密度推定の計算
 * @param kernel - カーネル関数
 * @param X - データ配列
 * @param bandwidth - バンド幅
 * @returns カーネル密度推定関数
 */
export function kernelDensityEstimator(
  kernel: (x: number) => number,
  X: number[],
  bandwidth: number
) {
  return (V: number[]) => {
    return V.map(x => {
      const mean = d3.mean(X, xi => kernel((x - xi) / bandwidth));
      return [x, (mean || 0) / bandwidth] as [number, number];
    });
  };
}
